var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlideNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "arrow-left-square-fill",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24393",
    "data-name": "Group 24393"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105875",
    "data-name": "Path 105875",
    d: "M0,36.75A5.25,5.25,0,0,0,5.25,42h31.5A5.25,5.25,0,0,0,42,36.75V5.25A5.25,5.25,0,0,0,36.75,0H5.25A5.25,5.25,0,0,0,0,5.25ZM11.813,19.688H27.019l-5.636-5.633A1.314,1.314,0,1,1,23.242,12.2l7.875,7.875a1.312,1.312,0,0,1,0,1.858L23.242,29.8a1.314,1.314,0,0,1-1.858-1.858l5.636-5.633H11.813a1.313,1.313,0,0,1,0-2.625Z",
    fill: "#5a32c7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlideNext);
export default __webpack_public_path__ + "static/media/slide-next.a474c460a4a34199f058d9909dd5ce78.svg";
export { ForwardRef as ReactComponent };